import { useState } from 'react';
import axios from '@helpers/axios';
import { ErrorMessage } from '@theme/theme';

export const useCancelSubscription = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<ErrorMessage | null>(null);

  const cancelSubscription = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.post('/v2/subscriptions/cancel');
      if (response.status === 200) {
        return response.data;
      }
    } catch (err) {
      setError({ message: 'Failed to cancel subscription' });
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    cancelSubscription,
  };
};
